export default "__VITE_ASSET__pS1Y4CkZ__"